import { CardType } from "..";
import { Activity, Task, Subtask } from "../../../store/types";
import { isSubtask, isTask } from "../../../store/use";

export const getCardType = (card: Activity | Task | Subtask): CardType => {
    if (isSubtask(card)) {
        return card.releaseId == null ? CardType.UnscheduledSubtask : CardType.Subtask;
    }

    if (isTask(card)) {
        return CardType.Task;
    }

    return CardType.Activity;
}
